import { RawAddress } from "../../../client";

export const breakDownAddressFieldByTiv = (
  field: keyof RawAddress,
  addresses: RawAddress[],
  totalTiv: number
) => {
  if (totalTiv === 0) {
    return "";
  }

  const fieldMap: { [key: string]: number } = {};
  for (const address of addresses) {
    const fieldValue = address[field];
    let stringValue =
      fieldValue === null || fieldValue === undefined || fieldValue === ""
        ? "Unknown"
        : fieldValue.toString();

    // Group by decade
    if (field === "year_built") {
      const year = parseInt(stringValue);
      const decade = Math.floor(year / 10) * 10;
      stringValue = `${decade}s`;
    }

    if (stringValue in fieldMap) {
      fieldMap[stringValue] += address.tiv;
    } else {
      fieldMap[stringValue] = address.tiv;
    }
  }

  let output = "";
  const entries = Object.entries(fieldMap).sort((a, b) => b[1] - a[1]);
  for (const [key, value] of entries) {
    // Ignore 0 tiv locations
    if (value === 0) {
      continue;
    }
    output += `${((value / totalTiv) * 100).toFixed(2)}% ${key}, `;
  }
  if (output.length > 1) {
    output = output.slice(0, output.length - 2);
  }

  return output;
};

export const capitalize = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
